<template>
  <div class="conteudoInterno" id="diretor-executivo">
    <div class="boxSeta">
      <div
        class="setaScrollstatic"
        style=""
        :class="{
          setaScroll: setaScrollState,
        }"
      >
        <button>
          <span><i class="bottom"></i></span>
        </button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Algumas palavras do nosso diretor-executivo</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked">
          <span><i class="left"></i></span>
        </button>
        <button @click="goNext()" :disabled="clicked">
          <span><i class="right"></i></span>
        </button>
      </div>
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcBlueBack"></span>
        </div>
      </section>
      <section class="sectionRow top65">
        <div class="col49">
          <img
            title="Marcelo Castelo Branco"
            alt="Marcelo Castelo Branco"
            src="../assets/imgs/marcelo_castelo_branco.jpg"
          />

          <h4 class="h4Destaque">
            “Nossa luta é para que a
            <span class="ubcBlue sanukBlack">inteligência artificial</span>
            respeite e remunere de forma compensatória os criadores — nossa
            máxima prioridade e nosso mantra.”
          </h4>
        </div>
        <div class="col40ponto4">
          <p>
            Uma distribuição recorde de 1 bilhão de reais. É a primeira vez que
            uma sociedade de gestão coletiva brasileira rompe essa barreira,
            honrando sua missão e sua determinação positivamente obsessivas de
            remunerar nossos cerca de 71 mil titulares diretos e mais de 200 mil
            em todo o mundo.
          </p>

          <p>
            A distribuição recorde reflete o cuidado com nossa rotina de
            processos, nosso investimento contínuo e cada vez mais material em
            tecnologia e inovação, além da reafirmação de uma sociedade de
            gestão progressista, inclusiva, diversa e com uma identidade
            construída em quase 85 anos de um olhar para o presente e para os
            desafios do futuro.
          </p>

          <p>
            Em 2025, estreamos novas versões de nosso site e do portal dos
            titulares, com novas aplicações mais modernas. A estrela principal é
            o nosso bot, que carinhosamente chamamos de Chiquinha, em homenagem
            à musicista Chiquinha Gonzaga.
            <span class="ubcBlue sanukBlack">Mulher</span> e
            <span class="ubcBlue sanukBlack">mestiça</span>, enfrentou todos os
            preconceitos da sociedade patriarcal e escravista para se firmar
            como pianista, compositora, regente e, por fim, líder de classe na
            defesa dos direitos autorais.
          </p>

          <p>
            A UBC continuou, durante todo o ano, homenageando em vida grandes
            personagens da música brasileira. Para a Medalha UBC, comemoramos a
            obra de Luiz Caldas, marcando os 40 anos da axé music. No Troféu
            Tradições UBC, a bossa de Rosa Passos, mundialmente celebrada por
            sua excelência musical e, no Brasil, injustamente pouco reconhecida.
            E, na já nona edição do Prêmio UBC, a obra do sambista e unanimidade
            nacional Zeca Pagodinho.
          </p>

          <p>
            Durante todo o ano, realizamos eventos de educação e conexão, seja
            na nova casa UBC (reinaugurada em março durante um evento do
            Conselho de Administração da Cisac no Rio de Janeiro), seja em São
            Paulo e nas outras diversas cidades brasileiras onde temos
            escritórios de atendimento e representação artística. Em
            reconhecimento ao dinâmico mercado do Ceará, inauguramos um novo
            escritório em Fortaleza.
          </p>

          <p>
            No campo político, seguimos atentos e muito atuantes em Brasília,
            onde, com a presença de vários titulares e da diretoria da UBC,
            continuamos a trabalhar por um ambiente regulatório ético e
            responsável para a questão da Inteligência Artificial no Brasil e no
            mundo. Nossa luta é para que essa tecnologia respeite e remunere de
            forma compensatória os criadores — nossa máxima prioridade e nosso
            mantra.
          </p>

          <p>
            Em 2026, a UBC foi reeleita uma vez mais para o Conselho de
            Administração da Cisac, e terminei, conforme previsto nos estatutos
            da instituição, meus seis anos como presidente do órgão nessa vital
            instituição, que reúne globalmente mais de 226 sociedades de gestão
            coletiva e cerca de 5 milhões de criadores de todo o mundo. Me
            orgulho dessa honra e de ter sido o único latino-americano a ocupar
            a função nos agora 100 anos da Cisac.
          </p>

          <p>
            Tudo isso apenas reflete o protagonismo e a seriedade com que a UBC
            representa o mandato de quem nos confia suas obras e catálogos, um
            compromisso de uma equipe coesa e incansável na busca de melhores
            práticas e estratégias, uma diretoria ativa e que apoia a gestão de
            forma objetiva e construtiva.
          </p>
          <p>
            E queremos mais. Mais para nossos titulares, para o talento, a arte
            e a diversidade de quem temos orgulho de representar.
          </p>

          <br />
          <p class="sanukBold ubcBlue">Marcelo Castello Branco</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from "../assets/js/functions.js";

export default {
  name: "PalavrasDiretorExecutivo",
  props: ["clicked"],
  data() {
    return {
      setaScrollState: false,
    };
  },
  mounted() {
    const conteudo = document.querySelector("#diretor-executivo");
    conteudo.addEventListener("scroll", ShareFunctions.headerScroll);
  },
  methods: {
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col49 img {
  width: 100%;
  max-width: 586px;
}
.h4Destaque {
  max-width: 586px;
  margin-top: 140px;
}
@media screen and (max-width: 800px) {
  .h4Destaque {
    max-width: unset;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
</style>
